// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-flex;
  align-self: center;
  place-self: center;
  position: relative;
}

:host([type=initials]),
:host([type=image]) {
  border-radius: 24px;
}

:host([type=module]) {
  border-radius: 4px;
}

:host([type=initials][color=blue]) {
  background-color: var(--ids-color-accent-blue-stronger);
  color: var(--ids-color-white-100);
}

:host([type=initials][color=green]) {
  background-color: var(--ids-color-accent-green-stronger);
  color: var(--ids-color-black-100);
}

:host([type=initials][color=orange]) {
  background-color: var(--ids-color-accent-orange-stronger);
  color: var(--ids-color-black-100);
}

:host([type=initials][color=red]) {
  background-color: var(--ids-color-accent-red-stronger);
  color: var(--ids-color-white-100);
}

:host([type=initials][color=gray]) {
  background-color: var(--ids-color-accent-neutral-stronger);
  color: var(--ids-color-white-100);
}

:host([type=initials][color=teal]) {
  background-color: var(--ids-color-accent-teal-stronger);
  color: var(--ids-color-black-100);
}

:host([type=initials][color=purple]) {
  background-color: var(--ids-color-accent-purple-stronger);
  color: var(--ids-color-white-100);
}

:host([type=module][color=blue]) {
  background-color: var(--ids-color-accent-blue-stronger);
  color: var(--ids-color-white-100);
}

:host([type=module][color=green]) {
  background-color: var(--ids-color-accent-green-stronger);
  color: var(--ids-color-black-100);
}

:host([type=module][color=orange]) {
  background-color: var(--ids-color-accent-orange-stronger);
  color: var(--ids-color-black-100);
}

:host([type=module][color=red]) {
  background-color: var(--ids-color-accent-red-stronger);
  color: var(--ids-color-white-100);
}

:host([type=module][color=gray]) {
  background-color: var(--ids-color-accent-neutral-stronger);
  color: var(--ids-color-white-100);
}

:host([type=module][color=teal]) {
  background-color: var(--ids-color-accent-teal-stronger);
  color: var(--ids-color-black-100);
}

:host([type=module][color=purple]) {
  background-color: var(--ids-color-accent-purple-stronger);
  color: var(--ids-color-white-100);
}

.ids-avatar {
  display: inline-flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.ids-avatar[type=image], .ids-avatar[type=initials] {
  width: 48px;
  height: 48px;
}
.ids-avatar[type=module] {
  width: 28px;
  height: 20px;
  padding: 6px 2px;
}
.ids-avatar .icon-container::before {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-white-100);
  content: "";
  width: 12px;
  height: 12px;
  left: 3px;
  top: 3px;
  z-index: 1;
}
.ids-avatar .icon-container {
  position: absolute;
  width: 18px;
  height: 18px;
  right: -1px;
  bottom: -3px;
}
.ids-avatar .icon-container[user-status=available] {
  color: var(--ids-image-status-available-color-background);
}
.ids-avatar .icon-container[user-status=away] {
  color: var(--ids-image-status-away-color-background);
}
.ids-avatar .icon-container[user-status=busy] {
  color: var(--ids-image-status-busy-color-background);
}
.ids-avatar .icon-container[user-status=do-not-disturb] {
  color: var(--ids-image-status-busy-color-background);
}
.ids-avatar .icon-container[user-status=unknown] {
  color: var(--ids-image-status-unknown-color-background);
}
.ids-avatar .icon-container[user-status=meeting] {
  color: var(--ids-image-status-busy-color-background);
}
.ids-avatar .icon-container ids-icon {
  z-index: 1;
}
.ids-avatar .icon-container::after {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-background-default);
  content: "";
  width: 16px;
  height: 16px;
  left: 1px;
  top: 1px;
}

.ids-avatar-image {
  min-width: 48px;
  max-width: 48px;
  width: 48px;
  height: 48px;
  border-radius: var(--ids-image-initials-border-radius);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-avatar/ids-avatar.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,uDAAA;EACA,iCAAA;AACF;;AAEA;EACE,wDAAA;EACA,iCAAA;AACF;;AAEA;EACE,yDAAA;EACA,iCAAA;AACF;;AAEA;EACE,sDAAA;EACA,iCAAA;AACF;;AAEA;EACE,0DAAA;EACA,iCAAA;AACF;;AAEA;EACE,uDAAA;EACA,iCAAA;AACF;;AAEA;EACE,yDAAA;EACA,iCAAA;AACF;;AAEA;EACE,uDAAA;EACA,iCAAA;AACF;;AAEA;EACE,wDAAA;EACA,iCAAA;AACF;;AAEA;EACE,yDAAA;EACA,iCAAA;AACF;;AAEA;EACE,sDAAA;EACA,iCAAA;AACF;;AAEA;EACE,0DAAA;EACA,iCAAA;AACF;;AAEA;EACE,uDAAA;EACA,iCAAA;AACF;;AAEA;EACE,yDAAA;EACA,iCAAA;AACF;;AAEA;EACE,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AACF;AACE;EAEE,WAAA;EACA,YAAA;AAAJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAIE;EACE,kBAAA;EACA,6CAAA;EACA,4CAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AAFJ;AAKE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAHJ;AAKI;EACE,yDAAA;AAHN;AAMI;EACE,oDAAA;AAJN;AAOI;EACE,oDAAA;AALN;AAQI;EACE,oDAAA;AANN;AASI;EACE,uDAAA;AAPN;AAUI;EACE,oDAAA;AARN;AAWI;EACE,UAAA;AATN;AAaE;EACE,kBAAA;EACA,6CAAA;EACA,qDAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AAXJ;;AAeA;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,sDAAA;AAZF","sourcesContent":[":host {\n  display: inline-flex;\n  align-self: center;\n  place-self: center;\n  position: relative;\n}\n\n:host([type='initials']),\n:host([type='image']) {\n  border-radius: 24px;\n}\n\n:host([type='module']) {\n  border-radius: 4px;\n}\n\n:host([type='initials'][color='blue']) {\n  background-color: var(--ids-color-accent-blue-stronger);\n  color: var(--ids-color-white-100);\n}\n\n:host([type='initials'][color='green']) {\n  background-color: var(--ids-color-accent-green-stronger);\n  color: var(--ids-color-black-100);\n}\n\n:host([type='initials'][color='orange']) {\n  background-color: var(--ids-color-accent-orange-stronger);\n  color: var(--ids-color-black-100);\n}\n\n:host([type='initials'][color='red']) {\n  background-color: var(--ids-color-accent-red-stronger);\n  color: var(--ids-color-white-100);\n}\n\n:host([type='initials'][color='gray']) {\n  background-color: var(--ids-color-accent-neutral-stronger);\n  color: var(--ids-color-white-100);\n}\n\n:host([type='initials'][color='teal']) {\n  background-color: var(--ids-color-accent-teal-stronger);\n  color: var(--ids-color-black-100);\n}\n\n:host([type='initials'][color='purple']) {\n  background-color: var(--ids-color-accent-purple-stronger);\n  color: var(--ids-color-white-100);\n}\n\n:host([type='module'][color='blue']) {\n  background-color: var(--ids-color-accent-blue-stronger);\n  color: var(--ids-color-white-100);\n}\n\n:host([type='module'][color='green']) {\n  background-color: var(--ids-color-accent-green-stronger);\n  color: var(--ids-color-black-100);\n}\n\n:host([type='module'][color='orange']) {\n  background-color: var(--ids-color-accent-orange-stronger);\n  color: var(--ids-color-black-100);\n}\n\n:host([type='module'][color='red']) {\n  background-color: var(--ids-color-accent-red-stronger);\n  color: var(--ids-color-white-100);\n}\n\n:host([type='module'][color='gray']) {\n  background-color: var(--ids-color-accent-neutral-stronger);\n  color: var(--ids-color-white-100);\n}\n\n:host([type='module'][color='teal']) {\n  background-color: var(--ids-color-accent-teal-stronger);\n  color: var(--ids-color-black-100);\n}\n\n:host([type='module'][color='purple']) {\n  background-color: var(--ids-color-accent-purple-stronger);\n  color: var(--ids-color-white-100);\n}\n\n.ids-avatar {\n  display: inline-flex;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n\n  &[type='image'],\n  &[type='initials'] {\n    width: 48px;\n    height: 48px;\n  }\n\n  &[type='module'] {\n    width: 28px;\n    height: 20px;\n    padding: 6px 2px;\n  }\n\n  .icon-container::before {\n    position: absolute;\n    border-radius: var(--ids-image-border-radius);\n    background-color: var(--ids-color-white-100);\n    content: \"\";\n    width: 12px;\n    height: 12px;\n    left: 3px;\n    top: 3px;\n    z-index: 1;\n  }\n\n  .icon-container {\n    position: absolute;\n    width: 18px;\n    height: 18px;\n    right: -1px;\n    bottom: -3px;\n\n    &[user-status='available'] {\n      color: var(--ids-image-status-available-color-background);\n    }\n\n    &[user-status='away'] {\n      color: var(--ids-image-status-away-color-background);\n    }\n\n    &[user-status='busy'] {\n      color: var(--ids-image-status-busy-color-background);\n    }\n\n    &[user-status='do-not-disturb'] {\n      color: var(--ids-image-status-busy-color-background);\n    }\n\n    &[user-status='unknown'] {\n      color: var(--ids-image-status-unknown-color-background);\n    }\n\n    &[user-status='meeting'] {\n      color: var(--ids-image-status-busy-color-background);\n    }\n\n    ids-icon {\n      z-index: 1;\n    }\n  }\n\n  .icon-container::after {\n    position: absolute;\n    border-radius: var(--ids-image-border-radius);\n    background-color: var(--ids-color-background-default);\n    content: \"\";\n    width: 16px;\n    height: 16px;\n    left: 1px;\n    top: 1px;\n  }\n}\n\n.ids-avatar-image {\n  min-width: 48px;\n  max-width: 48px;\n  width: 48px;\n  height: 48px;\n  border-radius: var(--ids-image-initials-border-radius);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
